import {
  Typography,
  Dialog as MUIDialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
} from "@mui/material";
import { CloseOutlined } from "@mui/icons-material";

import { colors } from "../../css components/Style";

export default function ViewAgreement({ viewAgreement, setViewAgreement }) {
  const handleClose = () => {
    setViewAgreement({
      data: viewAgreement?.data,
      state: false,
    });
  };

  return (
    <MUIDialog
      open={viewAgreement?.state}
      onClose={handleClose}
      PaperProps={{
        sx: {
          minWidth: "95%",
          height: "100%",
        },
      }}
    >
      <DialogTitle style={{ padding: "8px 24px" }}>
        <Grid container spacing={2}>
          <Grid size={7} style={{ alignSelf: "center" }}>
            <Typography color={colors.sprintexBlue} variant="h4">
              View Agreement
            </Typography>
          </Grid>

          <Grid size={5} textAlign={"end"}>
            <IconButton onClick={handleClose}>
              <CloseOutlined />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>

      <DialogContent>
        <div className="modal" style={{ height: "100%" }}>
          <div className="modalContent" style={{ height: "100%" }}>
            <iframe
              title="View Agreement"
              src={`${
                viewAgreement.data.is_verified
                  ? viewAgreement.data?.signed_agreement_link
                  : viewAgreement.data?.unsigned_agreement_link
              }#zoom=100`}
              style={{ width: "100%", height: "100%" }}
              frameborder="0"
            ></iframe>
          </div>
        </div>
      </DialogContent>
    </MUIDialog>
  );
}
